import React from 'react';
import { Analytics } from '@vercel/analytics/react';
import { SpeedInsights } from '@vercel/speed-insights/react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider as MuiThemeProvider } from '@mui/material';
import CssBaseline from '@mui/material/CssBaseline';
import Navbar from './components/Navbar';
import SaleBanner from './components/SaleBanner';
import Home from './components/Home';
import CoursesGrid from './components/CoursesGrid';
import Course from './components/Course';
import Table from './components/Table';
import Purchase from './components/Purchase';
import Privacy from './components/Privacy';
import Footer from './components/Footer';
import Legal from './components/Legal';
import RoadmapTree from './components/RoadmapTree';
import Quizzes from './components/Quizzes';
import Flashcards from './components/Flashcards';
import SignIn from './components/SignIn';
import { AuthProvider } from './contexts/AuthContext';
import { ThemeProvider, useTheme } from './contexts/ThemeContext';
import Profile from './components/Profile';
import Success from './components/Success';
import Subscription from './components/Subscription';
import AdminInfluencers from './components/AdminInfluencers';
import ProblemWorkspace from './components/ProblemWorkspace';
import SubscriptionTestingMode from './components/SubscriptionTestingMode';

function AppContent() {
  const { theme } = useTheme();

  return (
    <MuiThemeProvider theme={theme}>
      <CssBaseline />
      <Router>
        <SaleBanner />
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/signin" element={<SignIn />} />
          <Route path="/courses" element={<CoursesGrid />} />
          <Route path="/courses/:courseId" element={<Course />} />
          <Route path="/problems" element={<Table />} />
          <Route path="/problems/:problemSlug" element={<ProblemWorkspace />} />
          <Route path="/purchase" element={<Purchase />} />
          <Route path="/success" element={<Success />} />
          <Route path="/roadmap" element={<RoadmapTree />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/terms" element={<Legal />} />
          <Route path="/quizzes" element={<Quizzes />} />
          <Route path="/flashcards" element={<Flashcards />} />
          <Route path="/subscription" element={<Subscription />} />
          <Route path="/profile" element={<Profile />} />
          <Route path="/admin/influencers" element={<AdminInfluencers />} />
          <Route path="/dev/subscription-pages" element={<SubscriptionTestingMode />} />
        </Routes>
        <Footer />
        <Analytics />
        <SpeedInsights />
      </Router>
    </MuiThemeProvider>
  );
}

function App() {
  return (
    <AuthProvider>
      <ThemeProvider>
        <AppContent />
      </ThemeProvider>
    </AuthProvider>
  );
}

export default App;
